import BaseModel from '../../../logic/model/BaseModel';

export default class AuthorisationModel extends BaseModel {
  getListUrl() {
    return 'authenticator/v1/authorizations';
  }
}
